import * as yup from 'yup';
import { puzzleNameValidator } from 'validations/string';

import { strings } from '../strings';

export enum UploadField {
  Name = 'name',
  Keywords = 'keywords',
  Collection = 'collection',
  Image = 'image',
  ArtistId = 'Publisher',
  PremiumTier = 'premiumTier',
  SecondaryCollection = 'secondaryCollection',
  AIGenerated = 'aiGenerated',
  Status = 'status',
  ForceSetPublishDate = 'forceSetPublishDate',
  RejectMessage = 'rejectMessage',
}

export const uploadSchema = yup.object().shape({
  [UploadField.Name]: puzzleNameValidator(),
  [UploadField.Keywords]: yup.string().trim().required(strings.collectionKeywordsRequired),
  [UploadField.Collection]: yup
    .object()
    .shape({
      label: yup.string(),
      value: yup.string(),
    })
    .nullable()
    .required(strings.collectionIsRequired),
});

export const uploadVideoSchema = uploadSchema.shape({
  [UploadField.Status]: yup
    .object({
      label: yup.string(),
      value: yup.string().required(strings.statusRequired),
    })
    .required(strings.statusRequired),
});
